/* unplugin-vue-components disabled */import script from "./ActivityReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityReport.vue?vue&type=script&setup=true&lang=js"

import "./ActivityReport.vue?vue&type=style&index=0&id=2e5e0957&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e5e0957"]])

export default __exports__